export default __webpack_public_path__ + "static/media/P400_RoHS.af158167.pdf";